import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface PromotionTranslations {
    [lang: string]: string;
}

export interface PromotionPayload {
    title: PromotionTranslations;
    description: PromotionTranslations;
    requirements: PromotionTranslations;
    reward: string;
    prizeImageUrl: string;
    startDate: string;
    endDate: string;
    maxClaims: number;
    active: boolean;
    priority: number;
}

export interface PromotionListItem {
    id: string;
    title: string;
    reward: string;
    active: boolean;
    priority: number;
    startDate: string;
    endDate: string;
    maxClaims: number;
    languageCount: number;
}

export interface PromotionDetail extends PromotionPayload {
    id: string;
}

const COMMANDS = '/sa/sudokuvs/admin/commands';

export class PromotionManagementHandler {
    async getPromotions(): Promise<{ results: PromotionListItem[] }> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/GetAllPromotions`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async getPromotionDetails(promotionId: string): Promise<PromotionDetail> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/GetPromotionDetails?PromotionId=${encodeURIComponent(promotionId)}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async createPromotion(payload: PromotionPayload): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/CreatePromotion`;
        const content = JSON.stringify(payload);
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async updatePromotion(promotionId: string, payload: PromotionPayload): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/UpdatePromotion`;
        const content = JSON.stringify({ promotionId, ...payload });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async deletePromotion(promotionId: string): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const url = `${(client as any).baseUrl}${COMMANDS}/DeletePromotion`;
        const content = JSON.stringify({ promotionId });
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }
}
